import axios from 'axios'
import store from '@/store'

const h365PlatformApi = axios.create({
  // baseURL: process.env.VUE_APP_H365_PLATFORM_BASE_URL
  baseURL: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:3001/api/v1'
    : window && !process.env.VUE_APP_H365_PLATFORM_BASE_URL.startsWith('https://sapi.')
      ? 'https://api'+window.location.host.substring(window.location.host.indexOf('.'))+'/api/v1'
      : process.env.VUE_APP_H365_PLATFORM_BASE_URL
})

h365PlatformApi.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      ...(store.state.token && { Authorization: `Bearer ${store.state.token}` })
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

const clientLocationApi = axios.create({
  baseURL: process.env.VUE_APP_CLIENT_LOCATION_BASE_URL
})

export {
  h365PlatformApi,
  clientLocationApi
}
